import React, {useState} from 'react';
import { createGlobalStyle } from 'styled-components';
import { transferTokenFrom } from '../data';
import { removeExponents } from '../utils';

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    
  }
  .box-login p{
    color: #a2a2a2 !important;
  }
  .box-login{
    border-radius: 3px;
    padding: 40px 50px;
  }
`;

const TransferFromForm = () => {

  const [fromWalletAddress, setFromWalletAddress] = useState('');
  const [toWalletAddress, setToWalletAddress] = useState('');
  const [amount, setAmount] = useState(0);

  const handleFromAddressInputChanged = (event) =>{
    setFromWalletAddress(event.target.value);
  }

  const handleToAddressInputChanged = (event) =>{
    setToWalletAddress(event.target.value);
  }
  const handleAmountInputChanged = (event) =>{
    setAmount(event.target.value);
  }
  
  
  const handleButtonAction = async() => {
    if(fromWalletAddress===""||amount===""){
      alert("Wallet Address or Amount can't be empty");
    }else if(parseFloat(amount)<0 || parseFloat(amount)===0){
      alert("Amount can't be negative Or zero");
    }else{
      let convertedAmount = (amount*10**18).toString();
      if(convertedAmount.includes('e') || convertedAmount.includes('E')){
        convertedAmount = removeExponents(convertedAmount);
      }
      await transferTokenFrom(fromWalletAddress, toWalletAddress,convertedAmount);
    }
  }

  return(
<div>
<GlobalStyles/>
      <div className='container'>
        <div className='row align-items-center px-0'>
          <div className="col-lg-10 offset-lg-10 m-auto px-0">
            <div className="box-login">
              <h3 className="mb10">TRANSFER Token FROM Some Address</h3>
              <div  name="setBeneficiaryForm" id='setBeneficiaryForm' className="form-border">

                  <div className="field-set">
                      <input type='text' name='fromWalletAddress' id='fromWalletAddress' onChange={handleFromAddressInputChanged.bind(this)} className="form-control" placeholder="From Address"/>
                  </div>
                  <div className="field-set">
                      <input type='text' name='toWalletAddress' id='toWalletAddress' onChange={handleToAddressInputChanged.bind(this)} className="form-control" placeholder="To Address"/>
                  </div>
                
                 <div className="field-set">
                      <input type='number' name='amount' id='amount'  min="0" step="0.00000001" max="1000000000" onChange={handleAmountInputChanged.bind(this)} className="form-control" placeholder="Amount to Send"/>
                  </div>
                
                <div className="field-set">
                  <input type='submit' id='sendBtn' value='Send' onClick={async()=> await handleButtonAction()} className="btn btn-main btn-fullwidth color-2"/>
                </div>
                
                <div className="clearfix"></div>
                <div className="spacer-half"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
</div>
  )

}
export default TransferFromForm;